/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreManagementImportItemResponse } from './StoreManagementImportItemResponse';

export type StoreManagementImportItemResponseApiRespoonse = {
    data?: StoreManagementImportItemResponse;
    status?: StoreManagementImportItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreManagementImportItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

